import { Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { ShiftReportStackerBundle } from "@/pages/shift-report/models/ShiftReportResponse";
import { useTableData } from "./useTableData";

export const TableStackerBundles = ({
	bundles,
}: {
	bundles: ShiftReportStackerBundle[];
}) => {
	const { columnDefs } = useTableData();
	const { defaultColDef } = useGridDefinitions({});

	return (
		<Paper
			elevation={2}
			sx={{
				height: "100%",
				width: "100%",
				"& .ag-cell": {
					fontSize: 11,
				},
				"& .heat-cell": {
					paddingLeft: "2.5rem !important",
					display: "flex",
					alignItems: "center",
				},
			}}
		>
			<AgGridReact<ShiftReportStackerBundle>
				rowData={bundles || []}
				columnDefs={columnDefs}
				defaultColDef={defaultColDef}
				rowHeight={30}
				headerHeight={34}
				animateRows
				getRowId={(params) => params.data.GroupKey}
				loadingOverlayComponent={CenteredLazyLoading}
			/>
		</Paper>
	);
};
